/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const file_zip_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="m7.869 22.802 2.92-4.74v-1.049H6.172v1.198h2.81l-2.92 4.74V24h4.788v-1.198H7.869Zm8.708-4.592v-1.197H12.36v1.198h1.355v4.591H12.36V24h4.216v-1.198h-1.355v-4.591h1.355Zm4.021-1.197h-2.52V24h1.506v-2.695h1.014c1.515 0 2.398-.788 2.398-2.146 0-1.357-.883-2.146-2.398-2.146Zm-.241 3.094h-.773v-1.896h.773c.762 0 1.114.3 1.114.948 0 .649-.352.948-1.114.948Z"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M19.11 15.017V7.91c0-.37-.147-.726-.408-.987l-5.44-5.47a1.386 1.386 0 0 0-.982-.41H2.433c-.767 0-1.39.626-1.39 1.398v18.165c0 .772.623 1.398 1.39 1.398H4.5M19.11 8.03h-5.56c-.768 0-1.39-.625-1.39-1.397v-5.59"
    />
  </svg>
)
export default file_zip_medium
